import React from "react";
import PropTypes from "prop-types";
import { AiOutlineCaretDown } from "react-icons/ai";
import "./index.css";
import { Grid } from "@material-ui/core";

function ScoreNumber({ number, scoreNumber }) {
  const putScoreNumber = (number, isShown) => {
    return (
      <Grid container direction="column" justify="center">
        <Grid item>
          <AiOutlineCaretDown
            className={isShown ? "arrow-shown" : "arrow-hidden"}
            size={40}
          />
        </Grid>
        <Grid item className="score-numbers-position">
          <div
            className={
              (isShown ? "score-number-big" : "score-number-normal") +
              " score-number"
            }
          >
            {number}
          </div>
        </Grid>
      </Grid>
    );
  };

  return putScoreNumber(number, number === scoreNumber);
}

ScoreNumber.propTypes = {
  number: PropTypes.number.isRequired,
  scoreNumber: PropTypes.number.isRequired
};

export default ScoreNumber;



// WEBPACK FOOTER //
// ./src/components/RatingScoreCard/ScoreNumber/index.jsx